import { Deserializable } from '../deserializable';

export class UserBilling implements Deserializable {
  public id: number;
  public userId: number;
  public billingTypeId: number;
  public billedEntityId: number;
  public billedEntityType: string;
  public rate: number;

  static userBillingTypes: { Id: number; Name: string }[] = [
    { Id: 1, Name: 'Standard' },
    { Id: 2, Name: 'Premium' },
  ];

  static GetDisplayNameById(id: number): string | undefined {
    const userBillingType = UserBilling.userBillingTypes.find((type) => type.Id === id);
    return userBillingType?.Name;
  }
  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
